import React from 'react';
import { Link } from 'react-router-dom';
import { WHAT_WE_COLLECT } from '../../data/mock';
import { Check, AlertCircle, FileText } from 'lucide-react';

const WhatWeCollectSection = () => {
  return (
    <section className="section-padding bg-[#F8FAFC]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-2xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-[#111111]">
            What Transa collects
          </h2>
          <p className="mt-4 text-lg text-[#475569]">
            Focused on installer packaging from battery and electrical installations
          </p>
        </div>

        {/* Content Grid */}
        <div className="mt-10 grid md:grid-cols-2 gap-8 lg:gap-12">
          {/* Included */}
          <div className="bg-white rounded-2xl p-8 border border-[#E2E8F0] shadow-sm">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 rounded-full bg-[#F0FDFA] flex items-center justify-center">
                <Check className="w-5 h-5 text-[#0D9488]" />
              </div>
              <h3 className="text-xl font-bold text-[#111111]">What we collect</h3>
            </div>
            <ul className="space-y-4">
              {WHAT_WE_COLLECT.included.map((item, index) => (
                <li key={index} className="flex items-start gap-3">
                  <span className="flex-shrink-0 w-6 h-6 rounded-full bg-[#F0FDFA] flex items-center justify-center mt-0.5">
                    <Check className="w-3 h-3 text-[#0D9488]" />
                  </span>
                  <span className="text-[#475569]">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Excluded */}
          <div className="bg-white rounded-2xl p-8 border border-[#E2E8F0] shadow-sm">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 rounded-full bg-[#FEF3C7] flex items-center justify-center">
                <AlertCircle className="w-5 h-5 text-[#D97706]" />
              </div>
              <h3 className="text-xl font-bold text-[#111111]">Please note</h3>
            </div>
            <ul className="space-y-4">
              {WHAT_WE_COLLECT.excluded.map((item, index) => (
                <li key={index} className="flex items-start gap-3">
                  <span className="flex-shrink-0 w-6 h-6 rounded-full bg-[#FEF3C7] flex items-center justify-center mt-0.5">
                    <AlertCircle className="w-3 h-3 text-[#D97706]" />
                  </span>
                  <span className="text-[#475569]">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Service Conditions Link */}
        <div className="mt-8 text-center">
          <Link 
            to="/terms#battery-removal" 
            className="inline-flex items-center gap-2 text-sm text-[#7C3AED] hover:underline"
          >
            <FileText className="w-4 h-4" />
            View Battery Installation Service Conditions & Requirements
          </Link>
        </div>
      </div>
    </section>
  );
};

export default WhatWeCollectSection;
